export default "__VITE_ASSET__DnWJpKqp__"